import { render, staticRenderFns } from "./cateNextLvFooter.vue?vue&type=template&id=5ff6f23b&scoped=true&"
import script from "./cateNextLvFooter.vue?vue&type=script&lang=js&"
export * from "./cateNextLvFooter.vue?vue&type=script&lang=js&"
import style0 from "./cateNextLvFooter.vue?vue&type=style&index=0&id=5ff6f23b&prod&lang=scss&"
import style1 from "./cateNextLvFooter.vue?vue&type=style&index=1&id=5ff6f23b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff6f23b",
  null
  
)

export default component.exports